import { createContext, useMemo, useState, useCallback } from "react";
import jwtDecode from "jwt-decode";

export const AuthContext = createContext({
    UserId: null,
    roleUser: null,
    token :null,
    login: () => { },
    logout: () => { },
});

export function AuthContextProvider({ children }) {


    const decodeLocalStorage = (localStorageItem) => {
        const decodedItem =  jwtDecode(localStorage.getItem(localStorageItem))
         return{
             role: decodedItem.role,
             UserId: decodedItem.UserId
         }
    }
    
    const initialStateLoginProperties = {
            role:localStorage.getItem('accessToken')? decodeLocalStorage('accessToken').role: null,
            UserId: localStorage.getItem('accessToken')? decodeLocalStorage('accessToken').UserId: null,
            token :  localStorage.getItem('accessToken')? localStorage.getItem('accessToken'): null
    }

    const [roleUser, setRoleUser] = useState(initialStateLoginProperties.role);
    const [UserId, setUserId] = useState(initialStateLoginProperties.UserId);
    const [token, setToken] = useState(initialStateLoginProperties.token);

    const login = useCallback((accessToken) => {
        localStorage.setItem("accessToken",accessToken);
        const decodedToken = jwtDecode(accessToken);
        setUserId(decodedToken.UserId);
        setRoleUser(decodedToken.role);
        setToken(accessToken);
    }, [])
    const logout = useCallback(() => {
        localStorage.removeItem("accessToken");
        setRoleUser(null);
        setUserId(null);
        setToken(null);
    }, [])

    const memoedValue = useMemo(
        () => ({
            UserId,
            roleUser,
            token,
            login,
            logout,
        }),
        [UserId, roleUser, login, logout,token]
    );


    return (
        <AuthContext.Provider value={memoedValue}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContextProvider;